var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      attrs: { widget: _vm.widget },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "header-extra" },
                [
                  _c("ColumnToggle", {
                    attrs: {
                      "table-name": "queryPathMaps",
                      "user-settings": _vm.userSettings,
                      "settings-status": _vm.getUserSettingsStatus,
                      "column-settings": _vm.columnSettings
                    },
                    on: { onChange: _vm.updateUserVisibleColumns }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filters.name.value,
                        expression: "filters.name.value"
                      }
                    ],
                    staticClass:
                      "form-control input-md widget-header-input m-r-10",
                    attrs: {
                      type: "search",
                      placeholder: _vm.$t("PLACEHOLDER_URL_PARAMETER_SEARCH")
                    },
                    domProps: { value: _vm.filters.name.value },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.filters.name, "value", $event.target.value)
                      }
                    }
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "m-b-15" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success btn-sm",
                attrs: { type: "button", disabled: _vm.showCreateForm },
                on: { click: _vm.displayCreateForm }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "ACTION_CREATE_URL_PARAMETER",
                      expression: "'ACTION_CREATE_URL_PARAMETER'"
                    }
                  ]
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "grid_table_holder" },
            [
              _c(
                "v-table",
                {
                  staticClass: "table_beauty",
                  attrs: {
                    data: _vm.safeParameters,
                    "current-page": _vm.currentPage,
                    "page-size": 20,
                    filters: _vm.filters,
                    "hide-sort-icons": true
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    },
                    totalPagesChanged: function($event) {
                      _vm.totalPages = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function({ displayData }) {
                          return _c(
                            "tbody",
                            {},
                            [
                              _c("tr", [
                                _vm.emptyTable
                                  ? _c("td", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "URL_PARAMETERS_TABLE_EMPTY",
                                          expression:
                                            "'URL_PARAMETERS_TABLE_EMPTY'"
                                        }
                                      ],
                                      attrs: { colspan: "100%" }
                                    })
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _vm.showCreateForm
                                ? _c(
                                    "tr",
                                    {
                                      staticClass:
                                        "row-inline-new-form slide-down bg-row-even"
                                    },
                                    [
                                      _c(
                                        "td",
                                        { attrs: { colspan: "100" } },
                                        [
                                          _c("UrlParameterForm", {
                                            attrs: {
                                              "show-loader":
                                                _vm.createQueryParamStatus
                                                  .status === "pending" ||
                                                _vm.updateQueryParamStatus
                                                  .status === "pending",
                                              "is-new-url-parameter": true
                                            },
                                            on: {
                                              cancel: _vm.hideCreateForm,
                                              submit:
                                                _vm.checkForDuplicatesAndCreateUrlParameter
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(displayData, function(row, index) {
                                return [
                                  !(
                                    _vm.isMobile &&
                                    _vm.activeActionRowId == row.id
                                  )
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id,
                                          class: {
                                            "bg-row-odd": index % 2 === 0,
                                            "bg-row-even": index % 2 !== 0
                                          }
                                        },
                                        [
                                          _vm.isMobile
                                            ? _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-list-function btn-expand-actions",
                                                    attrs: {
                                                      disabled:
                                                        _vm.showCreateForm
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.displayMobileAction(
                                                          row.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-ellipsis-v"
                                                    })
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "incomingQueryStringName"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  staticClass: "clickable",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.displayEditForm(
                                                        row.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(
                                                        row.incomingQueryStringName
                                                      ) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "mapToTagType"
                                          )
                                            ? _c("td", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(row.mapToTagType) +
                                                    "\n            "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "mapToTagName"
                                          )
                                            ? _c("td", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(row.mapToTagName) +
                                                    "\n            "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isMobile
                                            ? _c(
                                                "td",
                                                [
                                                  _c("UrlParametersActions", {
                                                    attrs: {
                                                      "current-url-parameter": row,
                                                      disabled: _vm.disabled,
                                                      "get-references-status":
                                                        _vm.getReferencesStatus,
                                                      "delete-parameter-status":
                                                        _vm.deleteParameterStatus,
                                                      "url-param-references":
                                                        _vm.references
                                                    },
                                                    on: {
                                                      edit: _vm.displayEditForm,
                                                      "open-delete":
                                                        _vm.getUrlReferences,
                                                      "confirm-delete":
                                                        _vm.deleteUrlParameter
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showEditForm(row.id)
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id + "-edit",
                                          staticClass:
                                            "row-inline-new-form slide-down bg-row-even"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c("UrlParameterForm", {
                                                attrs: {
                                                  "show-loader":
                                                    _vm.createQueryParamStatus
                                                      .status === "pending" ||
                                                    _vm.updateQueryParamStatus
                                                      .status === "pending",
                                                  "current-url-parameter": row,
                                                  "is-new-url-parameter": false
                                                },
                                                on: {
                                                  cancel: _vm.hideEditForm,
                                                  submit:
                                                    _vm.checkForDuplicatesAndUpdateUrlParameter
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isMobile &&
                                  _vm.activeActionRowId == row.id
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id + "-mobile",
                                          staticClass:
                                            "mobile-actions ng-animate-disabled slide-right"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "10" } },
                                            [
                                              _c("UrlParametersActions", {
                                                attrs: {
                                                  "current-url-parameter": row,
                                                  disabled: _vm.disabled,
                                                  "get-references-status":
                                                    _vm.getReferencesStatus,
                                                  "delete-parameter-status":
                                                    _vm.deleteParameterStatus,
                                                  "url-param-references":
                                                    _vm.references
                                                },
                                                on: {
                                                  "collapse-actions": function(
                                                    $event
                                                  ) {
                                                    !_vm.disabled &&
                                                      _vm.hideMobileAction()
                                                  },
                                                  edit: _vm.displayEditForm,
                                                  "open-delete":
                                                    _vm.getReferences,
                                                  "confirm-delete":
                                                    _vm.deleteUrlParameter
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    3791569016
                  )
                },
                [
                  _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                    _c(
                      "tr",
                      [
                        _vm.isMobile ? _c("th") : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.userVisibleColumns, function(col) {
                          return _c("v-th", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: _vm.columnSettings[col].displayName,
                                expression: "columnSettings[col].displayName"
                              }
                            ],
                            key: col,
                            class: _vm.columnSettings[col].class,
                            attrs: {
                              "default-sort":
                                _vm.columnSettings[col].defaultSort,
                              "sort-key": _vm.columnSettings[col].name
                            }
                          })
                        }),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c("th", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "TABLE_COL_ACTIONS",
                                  expression: "'TABLE_COL_ACTIONS'"
                                }
                              ]
                            })
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pagination-min" }, [
                _c(
                  "div",
                  { staticClass: "text-center p-7" },
                  [
                    _c("smart-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage,
                        "total-pages": _vm.totalPages,
                        "max-page-links": 20
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "URL_PARAMETERS_TABLE_LOADING",
                    expression: "'URL_PARAMETERS_TABLE_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }